<template>
  <div class="tabs width1200">
    <ul class="d-flex d-flex-fw-w">
      <li
        v-for="(item, index) in tabsList"
        :key="index"
        class="d-flex d-flex-aifs d-flex-jc-c"
        :class="index == active ? 'active' : ''"
        :style="{ background: index == active ? item.color : 'none' }"
        @click="tabs(index)"
      >
        <img :src="index == active ? item.icon_active : item.icon" alt="" />
        <div class="li_right">
          <span>{{ item.title }}</span>
          <span>{{ item.en }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    tabsList: {
      type: Array,
      require: true,
    },
  },
  data () {
    return {
      active: 0,
    }
  },
  methods: {
    tabs (index) {
      this.active = index
      this.$bus.$emit("tabsEvent", index)
    },
  },
};
</script>

<style lang="less" scoped>
.tabs {
  ul {
    li {
      width: 290px;
      height: 123px;
      padding-top: 44px;
      border: 1px solid #b4b4b4;
      border-right: none;
      border-radius: 10px 10px 0 0;
      cursor: pointer;
      box-sizing: border-box;
      &:last-of-type {
        border-right: 1px solid #b4b4b4;
      }
      img {
        width: 23px;
        height: 23px;
      }
      .li_right {
        margin-left: 26px;
        span {
          display: block;
          &:nth-of-type(1) {
            line-height: 26px;
            font-size: 24px;
            font-weight: bold;
          }
          &:nth-of-type(2) {
            margin-top: 6px;
            font-size: 12px;
            text-transform: uppercase;
          }
        }
      }
      &.active {
        border-color: transparent;
        span {
          color: #fff;
        }
      }
    }
  }
}
@media (max-width: 1210px) {
  .tabs ul li {
    width: 25%;
  }
}
@media (max-width: 1024px) {
  .tabs ul li {
    width: 50%;
    height: 110px;
    padding-top: 32px;
    border: none !important;
    border-radius: 0;
  }
  .tabs ul {
    border: 1px solid #b4b4b4;
    border-bottom: none;
  }
  .tabs ul li:nth-of-type(1),
  .tabs ul li:nth-of-type(2) {
    border-bottom: 1px solid #b4b4b4 !important;
  }
}
@media (max-width: 768px) {
  .tabs ul li {
    width: 100%;
    height: 70px;
    padding-top: 12px;
    justify-content: flex-start;
  }
  .tabs ul li:nth-of-type(3) {
    border-bottom: 1px solid #b4b4b4 !important;
  }
  .tabs ul li .li_right span:nth-of-type(1) {
    font-size: 18px;
    line-height: 18px;
  }
  .tabs ul li img {
    width: 16px;
    height: 16px;
    margin-left: 2%;
  }
}
</style>
